import { render, staticRenderFns } from "./FormCustomer.vue?vue&type=template&id=34c30e88&scoped=true"
import script from "./FormCustomer.vue?vue&type=script&lang=js"
export * from "./FormCustomer.vue?vue&type=script&lang=js"
import style0 from "./FormCustomer.vue?vue&type=style&index=0&id=34c30e88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c30e88",
  null
  
)

export default component.exports